import { ReminderFrequencyEnum } from '__generated__/GQL';

import { SelectableFrequency } from './types';

/**
 *
 * @param frequency Frequency value from our DB model (ONCE or WEEKLY)
 * @param maxOccurrences Occurrences value from form input
 * @returns Frequency value from the REMINDER_FREQUENCIES select input
 */
export const mapReminderFrequencyWithSelectFrequency = (
  frequency: ReminderFrequencyEnum | null,
  maxOccurrences: number | null,
): SelectableFrequency | null => {
  if (frequency === 'ONCE' || frequency === null) {
    return 'ONCE';
  }
  if (maxOccurrences && maxOccurrences > 0) {
    return 'FOR_GIVEN_WEEKS';
  }
  return 'EVERY_WEEK_UNTIL_PAYMENT';
};

export const getMaxOccurrencesToSave = (
  frequency: SelectableFrequency | null,
  maxOccurrences: number,
) => {
  const isGivenWeeksFrequency = frequency === 'FOR_GIVEN_WEEKS';
  const isOnlyOnce = frequency === 'ONCE';

  if (isOnlyOnce) {
    return 0;
  }
  if (isGivenWeeksFrequency) {
    return maxOccurrences;
  }
  return -1;
};
